import React from 'react';
import styled from 'styled-components';
import Element from './Element';
import { PageContext } from '..';
import PageData, { PageType } from '../../models/PageData';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

const Engine: React.FC = () => {
  const { activePageId, experience } = React.useContext(PageContext);
  const [page, setPage] = React.useState<PageData>();

  const getPage = (): PageData => {
    const defaultPageIdx = experience.pages.findIndex((el) => el.id === PageType.SCREEN_DEFAULT);
    const defaultPage = experience.pages[defaultPageIdx];
    if (activePageId) {
      const pageIdx = experience.pages.findIndex((el) => el.id === activePageId);
      if (pageIdx !== -1) {
        return experience.pages[pageIdx];
      }
    }
    return defaultPage;
  };

  React.useEffect(() => {
    const newPage = getPage();
    setPage(newPage);
  }, [activePageId]);

  if (!page) return null;

  return (
    <Wrapper id={page.id}>
      {page.elements.map((el) => (
        <Element element={el} key={el.id} />
      ))}
    </Wrapper>
  );
};

export default Engine;
